import { UiTheme } from '../../theme'

export default (theme: UiTheme) => ({
  main: {
    base: {
      border: theme.settings.borders.regular,
      borderRadius: theme.settings.borderRadiuses.regular,
      backgroundColor: theme.colors.backgrounds.main,
      boxShadow: theme.settings.shadows.elevation[0],
      marginBottom: theme.settings.spacing.small,
    },

    flush: {
      marginBottom: 0,
    },

    variants: {
      normal: {},
      primary: {
        border: `1px solid ${theme.colors.accents.primaryBorder}`,
        backgroundColor: theme.colors.backgrounds.primary,
      },
      negative: {
        border: `1px solid ${theme.colors.accents.negativeBorder}`,
        backgroundColor: theme.colors.backgrounds.negative,
      },
    },

    expanded: {
      variants: {
        normal: {
          border: theme.settings.borders.regular,
          boxShadow: theme.settings.shadows.elevation[0],
        },
        primary: {
          border: `1px solid ${theme.colors.accents.primaryBorder}`,
          backgroundColor: theme.colors.backgrounds.primary,
          boxShadow: theme.settings.shadows.elevation[1],
        },
        negative: {
          border: `1px solid ${theme.colors.accents.negativeBorder}`,
          backgroundColor: theme.colors.backgrounds.negative,
          boxShadow: theme.settings.shadows.elevation[1],
        },
      },
    },
  },

  header: {
    base: {
      padding: `${theme.settings.spacing.medium} ${theme.settings.spacing.large}`,
      width: '100%',
      minHeight: '50px',
      boxSizing: 'border-box',
    },

    large: {
      minHeight: '70px',
    },

    expandable: {
      cursor: 'pointer',
    },
  },

  icon: {
    base: {
      marginRight: theme.settings.spacing.large,
    },
  },

  chevron: {
    base: {
      marginLeft: theme.settings.spacing.large,
    },
  },

  content: {
    base: {
      borderTop: `1px solid ${theme.settings.borders.regular}`,
      paddingTop: theme.settings.spacing.medium,
      margin: `0 ${theme.settings.spacing.large} ${theme.settings.spacing.large}`,
    },
    variants: {
      normal: {},
      primary: {
        borderTop: `1px solid ${theme.colors.accents.primaryBorder}`,
      },
      negative: {
        borderTop: `1px solid ${theme.colors.accents.negativeBorder}`,
      },
    },
  },
})
